import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onBeforeMount, watch } from 'vue';
import { useStore } from 'vuex';
import TheFlashMessages from '@/core/components/TheFlashMessages.vue';
import TheLoadingSpinner from '@/core/components/TheLoadingSpinner.vue';
import { AppStore } from '@/store';
import gettext from '@/gettext';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore<AppStore>();
const root = document.documentElement;
const themeKeys = {
	welcomeStart: 'welcome_start',
	welcomeEnd: 'welcome_end',
	menuTextColor: 'menu_text',
	menuIconColor: 'menu_icon',
	pageHeaderStart: 'page_header_start',
	pageHeaderEnd: 'page_header_end',
	tableHeaderStart: 'table_header_start',
	tableHeaderEnd: 'table_header_end',
	primaryButtonColor: 'primary_button',
	linkColor: 'link',
	linkHoverColor: 'link_hover',
};

const modalOpen = computed(() => store.state.modals.size > 0);

const handleWhitelabel = () => {
	const theme = store.getters.activeWhitelabeling;

	Object.entries(themeKeys).forEach(([varName, themeKey]) => {
		if (theme) {
			root.style.setProperty(`--${varName}`, `#${theme[themeKey]}`);
		} else {
			root.style.removeProperty(`--${varName}`);
		}
	});
};

const handleUserLanguage = () => {
	gettext.current = store.getters.userLanguage || 'sv';
};

watch(() => store.getters.activeWhitelabeling, handleWhitelabel);
watch(() => store.getters.userLanguage, handleUserLanguage);
onBeforeMount(handleWhitelabel);
onBeforeMount(handleUserLanguage);

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterView),
    _createVNode(TheFlashMessages),
    _createVNode(TheLoadingSpinner),
    _createElementVNode("div", {
      id: "modals",
      class: _normalizeClass(["modal-container", {open: modalOpen.value}])
    }, null, 2)
  ], 64))
}
}

})